import {useState} from 'react';
import {ArrowLeft,NotebookPen} from 'lucide-react';
import './WorkspaceNotes.css';

type StoredHome={ids?:string[];note?:string};
const keyFor=(workspaceId:string)=>'agentordinary-pinned-v4:'+workspaceId;
function readNote(workspaceId:string):string{
  try{
    const parsed=JSON.parse(localStorage.getItem(keyFor(workspaceId))||'null') as StoredHome|null;
    return typeof parsed?.note==='string'?parsed.note:'';
  }catch{return '';}
}
function saveNote(workspaceId:string,note:string):boolean{
  try{
    const key=keyFor(workspaceId);
    let old:StoredHome={};
    try{const value=JSON.parse(localStorage.getItem(key)||'null');if(value&&typeof value==='object'&&!Array.isArray(value))old=value;}catch{}
    // Keep the existing pinned layout untouched, so the Home and More views share one note.
    localStorage.setItem(key,JSON.stringify({...old,note}));
    return true;
  }catch{return false;}
}
export default function WorkspaceNotes({workspaceId,onBack,previewOnly=false}:{workspaceId:string;onBack?:()=>void;previewOnly?:boolean}){
  const [text,setText]=useState(()=>readNote(workspaceId));
  const [saved,setSaved]=useState(true);
  function update(next:string){setText(next);setSaved(saveNote(workspaceId,next));}
  return <section className="workspace-notes" aria-label="Notes">
    <div className="workspace-notes-heading">
      {onBack&&<button type="button" className="workspace-notes-back" onClick={onBack} aria-label="Back to More"><ArrowLeft size={19}/></button>}
      <span className="workspace-notes-symbol" aria-hidden="true"><NotebookPen size={23}/></span>
      <h1>Notes</h1>
      <span role="status" className="workspace-notes-save">{saved?'Saved':'Save unavailable'}</span>
    </div>
    <textarea aria-label="Notes" value={text} onChange={e=>update(e.target.value)} placeholder="Write a note..." spellCheck/>
    <p className="workspace-notes-caption">{previewOnly?'Saved on this device during design preview':'Saved in this browser. Account sync is not enabled for these notes.'}</p>
  </section>;
}
